"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioGroup = void 0;

var tslib_1 = require("tslib");

var ui_field_error_message_1 = require("@hopin-team/ui-field-error-message");

var ui_field_label_1 = require("@hopin-team/ui-field-label");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var use_id_1 = require("@hopin-team/use-id");

var react_1 = tslib_1.__importStar(require("react"));

var context_1 = require("./context");

var root_1 = require("./styled/root");

var RadioGroup = function RadioGroup(_a) {
  var __UIScope = _a.__UIScope,
      labelledBy = _a["aria-labelledby"],
      testID = _a["data-testid"],
      children = _a.children,
      className = _a.className,
      errorMessage = _a.errorMessage,
      hasErrors = _a.hasErrors,
      id = _a.id,
      isRequired = _a.isRequired,
      legend = _a.legend,
      name = _a.name,
      onChange = _a.onChange,
      _b = _a.pattern,
      pattern = _b === void 0 ? 'primary' : _b,
      renderLegend = _a.renderLegend,
      requiredText = _a.requiredText,
      selectedValue = _a.selectedValue;

  var _c = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'RadioGroup',
    className: className,
    __UIScope: __UIScope
  }),
      rootClasses = _c.rootClasses,
      makeClasses = _c.makeClasses;

  var isInverse = pattern === 'inverse';
  var contextValue = (0, react_1.useMemo)(function () {
    return {
      name: name,
      onChange: onChange,
      selectedValue: selectedValue,
      isInverse: isInverse,
      hasErrors: hasErrors
    };
  }, [name, onChange, selectedValue, isInverse, hasErrors]);

  var _id = (0, use_id_1.useId)(id);

  var fieldsetId = "field-".concat(_id);
  var errorMsgId = "error-msg-".concat(_id);
  var a11yProps = {};

  if (legend) {
    a11yProps['aria-labelledby'] = fieldsetId;
  }

  if (labelledBy) {
    a11yProps['aria-labelledby'] = labelledBy;
  }

  if (hasErrors && errorMessage) {
    a11yProps['aria-describedby'] = errorMsgId;
  }

  return react_1.default.createElement(root_1.Root, tslib_1.__assign({
    "data-testid": testID,
    role: "radiogroup",
    className: rootClasses
  }, a11yProps), legend && react_1.default.createElement(ui_field_label_1.FieldLabel, {
    className: makeClasses('Legend'),
    element: "legend",
    fieldId: fieldsetId,
    isLegend: true,
    label: legend,
    isRequired: isRequired,
    requiredText: requiredText,
    isInverse: isInverse,
    mb: 2
  }), renderLegend && renderLegend, react_1.default.createElement(context_1.RadioButtonsContext.Provider, {
    value: contextValue
  }, children), hasErrors && errorMessage && react_1.default.createElement(ui_field_error_message_1.FieldErrorMessage, {
    className: makeClasses('ErrorMessage'),
    mt: 1,
    errorMessage: errorMessage,
    id: errorMsgId
  }));
};

var RadioGroupWithSpace = (0, ui_helper_with_space_1.withSpace)(RadioGroup);
exports.RadioGroup = RadioGroupWithSpace;